import { default as AuditToggle } from "./AuditToggle.vue";
import { default as CopyableText } from "./CopyableText.vue";
import { default as InvoiceHeader } from "./InvoiceHeader.vue";
import { default as InvoiceInfo } from "./InvoiceInfo.vue";
import { default as InvoicePayment } from "./InvoicePayment.vue";
import { default as PaymentButtons } from "./PaymentButtons.vue";
import { default as PDFViewer } from "./PDFViewer.vue";

export const Misc = {
    AuditToggle: AuditToggle,
    CopyableText: CopyableText,
    InvoiceHeader: InvoiceHeader,
    InvoiceInfo: InvoiceInfo,
    InvoicePayment: InvoicePayment,
    PaymentButtons: PaymentButtons,
    PDFViewer: PDFViewer,
};
